import React, { useState } from 'react';

// Replace with your Google Translate API key
const GOOGLE_API_KEY = 'AIzaSyA9A30YcBJlwyqiCsbYLeGS0M_HtuT9dNg';

const speak = async (text, lang = 'en-US') => {
  try {
    const response = await fetch(`https://texttospeech.googleapis.com/v1/text:synthesize?key=${GOOGLE_API_KEY}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        input: { text },
        voice: {
          languageCode: lang,
          name: lang === 'hi-IN' ? 'hi-IN-Wavenet-A' : 'en-US-Wavenet-D', // Choose voices as per language
        },
        audioConfig: {
          audioEncoding: 'MP3',
        },
      }),
    });

    const data = await response.json();

    if (data.audioContent) {
      const audio = new Audio(`data:audio/mp3;base64,${data.audioContent}`);
      audio.play();
    } else {
      console.error('Error in TTS response:', data);
    }
  } catch (err) {
    console.error('Google TTS Error:', err);
  }
};

export const InteractivePassage = ({ text }) => {
  const [selectedWord, setSelectedWord] = useState('');
  const [hindiMeaning, setHindiMeaning] = useState('');
  const [showPopup, setShowPopup] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const translateToHindi = async (word) => {
    try {
      const res = await fetch(`https://translation.googleapis.com/language/translate/v2?key=${'AIzaSyA9A30YcBJlwyqiCsbYLeGS0M_HtuT9dNg'}`, {
        method: 'POST',
        body: JSON.stringify({
          q: word,
          source: 'en',
          target: 'hi',
          format: 'text',
        }),
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const data = await res.json();
      setHindiMeaning(data?.data?.translations[0]?.translatedText || 'Translation not found');
    } catch (err) {
      console.error('Translation error', err);
      setHindiMeaning('Error fetching translation');
    }
  };

  const handleWordClick = (word) => {
    setSelectedWord(word);
    setShowPopup(true);
    translateToHindi(word);
  };

  const closePopup = () => {
    setShowPopup(false);
    setSelectedWord('');
    setHindiMeaning('');
  };

  const words = text.split(' ');

  return (
 <div
  style={{
    position: 'relative',
    maxWidth: '100%',         // or use '600px'
    margin: '20px auto',     // center horizontally
    // padding: '20px',
    // border: '2px solid #e5e7eb',
    // borderRadius: '12px',
    // backgroundColor: '#f9fafb',
    // boxShadow: '0 2px 6px rgba(0, 0, 0, 0.05)',
  }}
>
  <div style={{ lineHeight: '1.625', fontSize: '16px', color: '#4b5563' }}>
    {words.map((word, index) => (
      <span
        key={index}
        onClick={() => handleWordClick(word.replace(/[.,!?]/g, ''))}
        style={{
          cursor: 'pointer',
          marginRight: 4,
        //   backgroundColor: '#fefce8',
          padding: '2px 4px',
          borderRadius: 4,
          display: 'inline-block',
        }}
      >
        {word}
      </span>
    ))}
  </div>
      {showPopup && (
        <div style={{
          position: 'fixed',
          top: '20%',
          left: '50%',
          transform: 'translateX(-50%)',
          backgroundColor: '#fff',
          padding: 16,
          border: '1px solid #ccc',
          borderRadius: 8,
          boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
          zIndex: 9999,
        }}>
          <p><strong>Word:</strong> {selectedWord}</p>
          <button onClick={() => speak(selectedWord)} style={buttonStyle}>🔊 Speak</button>
          <p><strong>Hindi Meaning:</strong> {hindiMeaning}</p>
          <button onClick={() => speak(hindiMeaning, 'hi-IN')} style={buttonStyle}>🔊 Speak Hindi</button>
          <br />
          <button onClick={() => setShowModal(true)} style={buttonStyle}>More</button>
          <button onClick={closePopup} style={{ ...buttonStyle, backgroundColor: '#f87171' }}>Close</button>
        </div>
      )}

      {showModal && (
        <div style={{
          position: 'fixed',
          top: '30%',
          left: '50%',
          transform: 'translateX(-50%)',
          backgroundColor: '#fff',
          padding: 20,
          border: '1px solid #ccc',
          borderRadius: 8,
          boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
          zIndex: 10000,
        }}>
          <h3>More Info</h3>
          <p>Coming soon...</p>
          <button onClick={() => setShowModal(false)} style={{ ...buttonStyle, marginTop: 10 }}>Close</button>
        </div>
      )}
    </div>
  );
};

const buttonStyle = {
  margin: '8px 4px',
  padding: '6px 12px',
  backgroundColor: '#2563eb',
  color: 'white',
  border: 'none',
  borderRadius: 4,
  cursor: 'pointer'
};
